// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"24290e4fcde6aa3fe78d","966":"926482363d24cc1a690d"}[chunkId] + ".js";
};